<template>
  <div class="itemList">
    <div class="itemList__listing">
      <div class="listview">
        <table>
          <thead class="none">
            <tr>
              <td class="listview__title items">ITEMS</td>
              <td class="listview__title placement">PLACEMENT</td>
              <td v-if="headers == 'ML' || headers == 'BU'" class="listview__title visitor">DAILY TRAFFIC</td>
              <td v-else class="listview__title visitor">DAILY VISITOR</td>
              <td class="listview__title price">PRICE / DAY</td>
              <td class="save"></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index" class="content" @click.stop="listClick(item)">
              <td class="items">
                <div class="item">
                  <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="title">{{item.location_name}}</span>
                    <span class="location">{{item.property_type_display}} . {{item.city_name}}</span>
                    <span class="price-mobile">{{item.price | formatMoney}}</span>
                  </div>
                </div>
              </td>
              <td class="placement none"><span>{{ item.placement }}</span></td>
              <td v-if="item.is_audience_displayed" class="visitor none"><span>{{item.audience_daily}} people</span></td>
              <td v-else class="visitor none">-</td>
              <td class="price none"><span>{{ item.price | formatMoney }}</span></td>
              <td class="icon-list" @click.stop="addRemoveDevice(item)">
                <!-- <adx-tooltip text="Add to collection"> -->
                <span slot="content">
                  <adx-loading-secondary v-if="isLoading.includes(item.id)"/>
                  <button v-if="!isLoading.includes(item.id)" class="btn-small secondary">Add</button>
                </span>
                <!-- </adx-tooltip> -->
              </td>
            </tr>
          </tbody>
          <slot name="infiniteLoading"/>
        </table>
      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !loading"/>
      </div>
      <div class="listview__loadingWrapper">
        <slot name="loading" />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/Tooltip'
import MenuExpansion from '@/components/MenuExpansion'
import EmptySelection from '@/components/NotFound/Selection'
import LoadingSecondary from '@/components/Loading/Secondary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions, mapMutations } from 'vuex'


export default {
    name: 'adx-listaddmore-collection',
    components: {
      'adx-tooltip': Tooltip,
      'adx-menu-expansion': MenuExpansion,
      'adx-empty-selection': EmptySelection,
      'adx-loading-secondary': LoadingSecondary,
    },
    props: {
      items: {
        required: false
      },
      loading: {
        required: false
      },
      headers: {
        required: false
      },
      channel: {
        required: false
      },
    },
    data () {
      return {
        isEmpty: false,
        isLoading: [],
      }
    },
    computed: {
      ...mapGetters ({
        defaultSaved: 'default',
        token: 'token'
      }),
    },
    watch: {

    },
    beforeCreate() {

    },
    created() {

    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {
      if(this.items == 0) {
        this.isEmpty = true
      }else {
        this.isEmpty = false
      }
    },
    activated() {

    },
    deactivated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      addRemoveDevice(item) {
        const isLogin = this.token
        let category = this.channel.toLowerCase()

        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'device'
        }

        let data = {
          'device_id': item.id,
          'channel_type': category,
        };

        (async () => {
          this.isLoading.push(item.id)

          if (isLogin) {
            const response = await api.patch(apiV2.CollectionAddListing(this.$route.params.id), data, { needToken: true })
            let item2 = this.items.filter(value => {
              return value.id == item.id
            })[0]
            this.$notify({
              group: 'saved',
              title: 'Added to collection',
              text: item2.location_name + ' has been added to collection',
              type: 'success'
            })
          } else {
            this.$router.push({name: 'signin', query: { next: this.$route.name }})
          }
          this.isLoading = []
          this.$emit('reloadData')
        })();
      },
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
